module.exports = __webpack_public_path__ + "img/user_icon_251290.b274670c.png";